<template>
	<section>
	<b-card no-body class="mb-3 overflow-hidden" bg-variant="dark">
		<b-row no-gutters>
			<b-col md="6">
				<b-img fluid v-b-tooltip.hover :title="image_alt" :alt="image_alt" :src="require('../assets/' + this.image + '-75.png')" class="rounded-0"></b-img>
					<div class="px-4 pt-2 pb-0 py-md-4">
						<b-card-title class="text-secondary">{{car}}</b-card-title>
						<b-card-sub-title class="mb-2">{{sub_title}}</b-card-sub-title>
					</div>
			</b-col>
			<b-col md="6">
				<b-card-body>
					<b-list-group v-if="show_list" flush>
						<b-list-group-item>Full services</b-list-group-item>
						<b-list-group-item>Engine</b-list-group-item>
						<b-list-group-item>Brakes</b-list-group-item>
						<b-list-group-item>Suspension</b-list-group-item>
						<b-list-group-item>Exhaust</b-list-group-item>
						<b-list-group-item>Compression Tests</b-list-group-item>
						<b-list-group-item>Full Engine Rebuilds (2 yr or 24000 mi guarantee)</b-list-group-item>
						<b-list-group-item>Misc parts <a href="#contact">(contact for availability)</a></b-list-group-item>
					</b-list-group>
					<div v-else>

						<b-list-group flush>
							<b-list-group-item>Citroen Bi/rotor engines</b-list-group-item>
							<b-list-group-item>SUZUKI RE-5</b-list-group-item>
							<b-list-group-item>Norton</b-list-group-item>
							<b-list-group-item>DKW</b-list-group-item>
							<b-list-group-item>Van Veen</b-list-group-item>
							<b-list-group-item>Fishell & Sachs (ZF Sachs AG)</b-list-group-item>
						</b-list-group>
					</div>
				</b-card-body>
			</b-col>
		</b-row>
	</b-card>	
	</section>
</template>
<script>
export default {
  name: 'ServiceCars',
  props: {
    msg: String,
    car: String,
    sub_title: String,
    image_alt: String,
    show_list:{
		type: Boolean,
		default: true
    },
    // defines the image name
    image:String,
  },

}
</script>